import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {Pagination} from 'antd'
import {Link} from 'react-router-dom'
import LoaderInTable from '../../../components/loader/LoaderInTable'
import BlankDataImageInTable from '../../../components/basic/BlankDataImageInTable'
import {UserModel} from '../../../modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {Button, Modal} from 'react-bootstrap-v5'
import {RootState} from '../../../../setup'
import {IActiveSubscriptionModel} from '../../../models/partner-manage-model/IPackageModel'
import {KTSVG} from '../../../../_ShakWala/helpers'
import {IPartnerModel} from '../../../models/partner-manage-model/IPartnerModel'
import {GetAllPartner_GetListAPI} from '../../../modules/partner-manage-page/partner-page/PartnerCRUD'
import {ExpAfterFiveDayCard} from './ExpAfterFiveDayCard'
import {GetPartnerAfterFiveDays_ExpirePackage_GetListAPI} from '../../../modules/package-info-master-page/PackageInfoCRUD'

interface IItem {
  loading: boolean
  packageDetailsData: IActiveSubscriptionModel[]
  tmpPackageDetailsData: IActiveSubscriptionModel[]
  partnerData: IPartnerModel[]
  tmpPartnerData: IPartnerModel[]
  selPartnerID: number
  selPartnerName: string
}

type Props = {}

const ExpAfterFiveDay: React.FC<Props> = () => {
  const [mainLoading, setMainLoading] = useState<boolean>(false)
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const [state, setState] = useState<IItem>({
    loading: false,
    packageDetailsData: [] as IActiveSubscriptionModel[],
    tmpPackageDetailsData: [] as IActiveSubscriptionModel[],
    partnerData: [] as IPartnerModel[],
    tmpPartnerData: [] as IPartnerModel[],
    selPartnerID: 0,
    selPartnerName: '',
  })

  useEffect(() => {
    setState({...state, loading: true})
    setTimeout(() => {
      getPackageDetailsData(state.selPartnerID, state.selPartnerName)
    }, 100)
  }, [])

  // ==================== Get Item API Call===================
  function getPackageDetailsData(temPartnerID: number, temPartnerName: string) {
    GetPartnerAfterFiveDays_ExpirePackage_GetListAPI()
      .then((response) => {
        let responseData = response.data.responseObject
        if (response.data.isSuccess === true) {
          getPartnerData(responseData, temPartnerID, temPartnerName)
          setTotal(responseData.length)
        } else {
          toast.error(`${response.data.message}`)
          setState({...state, packageDetailsData: [], loading: false})
        }
      })
      .catch((error) => {
        toast.error(`${error}`)
        setState({...state, packageDetailsData: [], loading: false})
      })
  }

  function getPartnerData(
    packageDetailsData: IActiveSubscriptionModel[],
    temPartnerID: number,
    temPartnerName: string
  ) {
    GetAllPartner_GetListAPI()
      .then((response) => {
        let responseData = response.data.responseObject
        if (response.data.isSuccess === true) {
          setState({
            ...state,
            packageDetailsData: packageDetailsData,
            tmpPackageDetailsData: packageDetailsData,
            partnerData: responseData,
            tmpPartnerData: responseData,
            selPartnerID: temPartnerID,
            selPartnerName: temPartnerName,
            loading: false,
          })
          setTotalPartner(responseData.length)
        } else {
          toast.error(`${response.data.message}`)
          setState({...state, partnerData: [], loading: false})
        }
      })
      .catch((error) => {
        toast.error(`${error}`)
        setState({...state, partnerData: [], loading: false})
      })
  }

  // ============== Partner Search Function =======================
  const [namePartner, setNamePartner] = useState('')
  const filterPartner = (e: any) => {
    const keyword = e.target.value
    if (keyword !== '') {
      const results = state.tmpPartnerData.filter((user) => {
        return (
          user.packageName.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.partnerName.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.contactPerson.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.contactNumber.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.emailID.toLowerCase().startsWith(keyword.toLowerCase())
        )
      })
      setState({...state, partnerData: results, loading: false})
      setTotal(results.length)
    } else {
      setState({...state, partnerData: state.tmpPartnerData, loading: false})
      setTotal(state.tmpPartnerData.length)
    }
    setNamePartner(keyword)
  }

  // ============== Subscription Search Function =======================
  const [name, setName] = useState('')
  const filter = (e: any) => {
    const keyword = e.target.value
    if (keyword !== '') {
      const results = state.tmpPackageDetailsData.filter((user) => {
        return (
          user.packageName.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.partnerName.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.durationDays.toString().startsWith(keyword.toLowerCase()) ||
          user.packageExpireDate.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.price.toString().startsWith(keyword.toLowerCase()) ||
          user.remainingDays.toString().startsWith(keyword.toLowerCase())
        )
      })
      setState({...state, packageDetailsData: results, loading: false})
      setTotal(results.length)
    } else {
      setState({...state, packageDetailsData: state.tmpPackageDetailsData, loading: false})
      setTotal(state.tmpPackageDetailsData.length)
    }
    setName(keyword)
  }

  // ======================= Partner Model PopUp ======================
  const [showPartner, setShowPartner] = useState(false)
  function handleClosePartner() {
    setShowPartner(false)
  }

  function handleShowPartner() {
    setShowPartner(true)
  }

  // --------For Model Data onClick Function-------
  function selectPartner(tmpPartnertData: IPartnerModel) {
    let PartnerID: number = tmpPartnertData.partnerID
    let PartnerName: string = tmpPartnertData.partnerName
    getPackageDetailsData(PartnerID, PartnerName)
    setState({...state, loading: true})
    setShowPartner(false)
  }

  // -------------------- Partner Pagination ------------------------
  const onShowSizeChangePartner = (current: any, pageSize: any) => {
    setPostPerPagePartner(pageSize)
  }

  const [totalPartner, setTotalPartner] = useState(0) //  length
  const [pagePartner, setPagePartner] = useState(1)
  const [postPerPagePartner, setPostPerPagePartner] = useState(10)
  const indexOfLastPagePartner = pagePartner * postPerPagePartner
  const indexOfFirstPagePartner = indexOfLastPagePartner - postPerPagePartner
  const currentPostsPartner: IPartnerModel[] = state.partnerData.slice(
    indexOfFirstPagePartner,
    indexOfLastPagePartner
  )

  // ---------------------- Subscriptio Pagination----------------------------
  const onShowSizeChange = (current: any, pageSize: any) => {
    setPostPerPage(pageSize)
  }

  const [total, setTotal] = useState(0) //  length
  const [page, setPage] = useState(1)
  const [postPerPage, setPostPerPage] = useState(10)
  const indexOfLastPage = page * postPerPage
  const indexOfFirstPage = indexOfLastPage - postPerPage
  const currentPosts: IActiveSubscriptionModel[] = state.packageDetailsData.slice(
    indexOfFirstPage,
    indexOfLastPage
  )

  return (
    <>
      <div className={`card `}>
        {/* <div
          className='card-header border-0 bg-secondary'
          // style={{backgroundColor: '#000000', justifyContent: 'initial'}}
        >
          <div className='mb-2 d-flex ms-2'>
            <label className='text-dark mt-5 fw-bold fs-5'>Select Partner : </label>
            <span className='mt-5 fw-bolder fs-6 text-primary d-flex align-item-center fs-5'>
              &nbsp;{state.selPartnerName}
            </span>
            <div className='fv-row'>
              <div
                className='mt-3 btn btn-icon btn-bg-primary bg-hover-dark text-hover-inverse-dark btn-sm me-1 p-5 ms-2'
                onClick={handleShowPartner}
              >
                <KTSVG
                  path='/media/icons/duotune/general/gen004.svg'
                  className='svg-icon-2 svg-icon-white'
                />
              </div>
            </div>
          </div>
          <div className='card-header border-0 pt-4 ps-0' id='kt_chat_contacts_header'>
            <form className='w-100 position-relative' autoComplete='off'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute pt-14 ms-5 translate-middle-y'
              />
              <input
                type='text'
                className='form-control form-control-solid px-15 bg-white'
                name='search'
                placeholder='Search'
                onChange={(e) => filter(e)}
                value={name}
              />
            </form>
          </div>
          <div
            className='card-toolbar'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click to add a Subscription'
          >
            <Link
              to='/partner-manage/subscription/add'
              className='btn btn-sm btn-light-primary bg-white'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              Add New
            </Link>
          </div>
        </div> */}
        {/* end::Header */}
        {/* <CountryCard data={currentPosts} /> */}
        {/* begin::Body */}
        <div className='py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-striped align-middle g-4'>
              {/* begin::Table head */}
              <thead className='bg-primary'>
                <tr className='fw-bolder fs-5 text-white'>
                  <th className='min-w-150px'>Partner Name</th>
                  <th className='min-w-150px'>Package Name</th>
                  <th className='min-w-150px'>Expiry Date</th>
                  <th className='min-w-50px'>Duration Days</th>
                  <th className='min-w-50px'>Remaining Days</th>
                  <th className='min-w-150px'>Amount</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {state.loading ? (
                  <LoaderInTable loading={state.loading} column={8} />
                ) : (
                  <>
                    {currentPosts.length > 0 &&
                      currentPosts.map((data, index) => {
                        return <ExpAfterFiveDayCard data={data} />
                      })}
                    {/* =================== Loading get Api Data ============== */}
                    <BlankDataImageInTable
                      length={currentPosts.length}
                      loading={state.loading}
                      colSpan={8}
                    />
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className='text-center'>
            <Pagination
              onChange={(value: any) => setPage(value)}
              pageSize={postPerPage}
              total={total}
              current={page}
              showSizeChanger
              showQuickJumper
              onShowSizeChange={onShowSizeChange}
              showTotal={(total) => `Total ${total} items`}
            ></Pagination>
          </div>
        </div>
      </div>

      {/* ----------------------------Partner Model PopUp---------------------- */}
      <Modal size='xl' scrollable={true} show={showPartner} onHide={handleClosePartner}>
        <div style={{backgroundColor: '#2a3952'}}>
          <Modal.Header closeButton>
            <Modal.Title style={{color: 'white'}}>Shop Data</Modal.Title>
            <div className='border-0 pt-4' id='kt_chat_contacts_header'>
              <form className='w-100 position-relative' autoComplete='off'>
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute pt-14 ms-5 translate-middle-y'
                />
                <input
                  type='text'
                  className='form-control form-control-solid px-15 bg-white'
                  placeholder='Search'
                  onChange={filterPartner}
                  value={namePartner}
                />
              </form>
            </div>
          </Modal.Header>
        </div>
        <Modal.Body style={{maxHeight: '65vh', overflowY: 'auto'}}>
          <div className='card-body py-3'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bolder fs-5'>
                    <th className='min-w-120px'>
                      <span className='d-block mb-1 ps-1'>Business Name</span>
                    </th>
                    <th className='min-w-150px'>
                      <span className='d-block mb-1 ps-2'>Contact Person</span>
                    </th>
                    <th className='min-w-128px'>
                      <span className='d-block mb-1 ps-2'>Contact Number</span>
                    </th>
                    <th className='min-w-150px'>
                      <span className='d-block mb-1'>EmailID</span>
                    </th>
                    <th className='min-w-150px'>
                      <span className='d-block mb-1'>Package</span>
                    </th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody className='border-bottom cursor-pointer'>
                  {currentPostsPartner.length > 0 &&
                    currentPostsPartner.map((data, index) => {
                      return (
                        <tr key={index} onClick={() => selectPartner(data)}>
                          <td>
                            <span className='text-dark text-hover-primary d-block ps-1 mb-1 fs-6'>
                              {data.partnerName}
                            </span>
                          </td>
                          <td>
                            <div className='d-flex align-items-center'>
                              <div className='text-dark text-hover-primary fs-6'>
                                {data.contactPerson}
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className='text-dark text-hover-primary d-block ps-2 mb-1 fs-6'>
                              {data.contactNumber}
                            </span>
                          </td>
                          <td className=''>
                            <span className='text-dark text-hover-primary d-block ps-2 mb-1 fs-6'>
                              {data.emailID}
                            </span>
                          </td>
                          <td className=''>
                            <span className='text-dark text-hover-primary d-block ps-2 mb-1 fs-6'>
                              {data.packageName}
                            </span>
                          </td>
                        </tr>
                      )
                    })}
                  <BlankDataImageInTable
                    length={currentPosts.length}
                    loading={state.loading}
                    colSpan={9}
                  />
                </tbody>
              </table>
            </div>
            <div className='text-center'>
              <Pagination
                onChange={(value: any) => setPage(value)}
                pageSize={postPerPagePartner}
                total={totalPartner}
                current={pagePartner}
                showSizeChanger
                showQuickJumper
                onShowSizeChange={onShowSizeChangePartner}
                showTotal={(totalPartner) => `Total ${totalPartner} items`}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='danger' onClick={handleClosePartner}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default ExpAfterFiveDay
